import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Book } from '../model/book.model';
import { BookService } from '../services/book.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'bs-edit-book',
  templateUrl: './edit-book.component.html',
  styleUrls: ['./edit-book.component.css']
})
export class EditBookComponent implements OnInit {
  book :Book;
	bookForm :FormGroup;

  	constructor(private fb: FormBuilder, private bookService :BookService, private router :Router,
      private route :ActivatedRoute) { 
  		this.createForm();
  	}

  ngOnInit() {
    let id :string = this.route.snapshot.params.id;
    if (id){
      this.book = this.bookService.get(Number(id));
      this.bookForm.patchValue(this.book);
    }
  }

  createForm(){
    this.bookForm = this.fb.group({
      'title': ["", [Validators.required, Validators.minLength(2)]],
      'author': ["", Validators.required],
      'year': ["", Validators.required],
      'country': ["", Validators.required],
      'borrower': ["", Validators.required]
    });
  }

  onSubmit(){
    let submittedBook :Book = new Book(this.bookForm.value);
    if(this.book && this.book._id) {
      submittedBook._id = this.book._id;
      this.bookService.update(submittedBook);
    } else {
      this.bookService.add(submittedBook);
    }
    this.bookForm.reset();
    this.router.navigate(['books/']);
  }
}
